import { render, staticRenderFns } from "./formRealisasiPemanfaatanRuangLaut.vue?vue&type=template&id=2ad682e0&"
import script from "./formRealisasiPemanfaatanRuangLaut.vue?vue&type=script&lang=js&"
export * from "./formRealisasiPemanfaatanRuangLaut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports